/* NA LEIBERL – Gelato Personalizer:
   1) deutsche Bezeichnungen, gewaehlter Wert in der Ueberschrift, Farbkreise
   2) Personalisierungs-Texte (z. B. Geburtsjahr) als sichtbare Eigenschaft mit in den Warenkorb/die Bestellung geben,
      damit Kunden im Einkaufswagerl sehen, was sie eingegeben haben (Gelato speichert selbst nur eine interne Design-ID).
      Gelato legt Produkte per fetch('/cart/add.js') in den Warenkorb -> diese Anfrage wird hier um die Texte ergaenzt.
   3) Nach dem Hinzufuegen oeffnet sich die Seitenansicht (Einkaufswagerl) statt der Weiterleitung auf /cart,
      die Gelato sonst macht. Klappt etwas nicht, bleibt Gelatos normales Verhalten (Weiterleitung). */
(function () {
  // Gelato-Bezeichnungen -> Anzeige im Shop
  var LABELS = { 'size': 'Größe', 'color': 'Farbe', 'colour': 'Farbe' };
  // Labels, bei denen der gewaehlte Wert rechts daneben angezeigt wird
  var SHOW_VALUE = /^(größe|farbe)$/i;
  var COLOR_LABEL = /^(farbe|color|colour)$/i;
  var NL_COLORS = {
    'weiß': '#FFFFFF', 'weiss': '#FFFFFF', 'white': '#FFFFFF',
    'schwarz': '#1C1A1B', 'black': '#1C1A1B',
    'marine': '#1F2A44', 'navy': '#1F2A44', 'dunkelblau': '#1F2A44', 'french navy': '#1F2A44',
    'blau': '#2F5DA8', 'blue': '#2F5DA8', 'royal': '#2B4FA3', 'hellblau': '#A9C6E8', 'sky blue': '#A9C6E8',
    'grau': '#9C9C9C', 'grey': '#9C9C9C', 'gray': '#9C9C9C', 'heather grey': '#B9B9B9', 'grau meliert': '#B9B9B9', 'sport grey': '#B9B9B9', 'hellgrau': '#D3D3D3',
    'anthrazit': '#3A3A3C', 'dark grey': '#3A3A3C', 'charcoal': '#3A3A3C', 'dunkelgrau': '#3A3A3C',
    'rot': '#C42A30', 'red': '#C42A30', 'bordeaux': '#6B1E2A', 'burgundy': '#6B1E2A', 'weinrot': '#6B1E2A',
    'grün': '#2E6B3F', 'gruen': '#2E6B3F', 'green': '#2E6B3F', 'flaschengrün': '#1F4A33', 'bottle green': '#1F4A33', 'oliv': '#6B6B3A', 'olive': '#6B6B3A', 'khaki': '#8A845C',
    'beige': '#D9C7A7', 'sand': '#D9C7A7', 'creme': '#F1EBDD', 'cream': '#F1EBDD', 'natur': '#EFE8D8', 'natural': '#EFE8D8', 'ecru': '#EFE8D8', 'off-white': '#F4F1E8',
    'braun': '#6B4A2F', 'brown': '#6B4A2F', 'gelb': '#F3D23B', 'yellow': '#F3D23B', 'orange': '#E8772E',
    'rosa': '#F2B6C6', 'pink': '#F2B6C6', 'lila': '#7A5C9E', 'purple': '#7A5C9E', 'flieder': '#C8B6E2'
  };
  var COLOR_KEYS = Object.keys(NL_COLORS).sort(function (a, b) { return b.length - a.length; });
  function colorFor(name) {
    var key = (name || '').trim().toLowerCase();
    if (NL_COLORS[key]) return NL_COLORS[key];
    for (var i = 0; i < COLOR_KEYS.length; i++) { if (key.indexOf(COLOR_KEYS[i]) !== -1) return NL_COLORS[COLOR_KEYS[i]]; }
    return null;
  }
  function isLight(hex) {
    var h = hex.replace('#', '');
    var r = parseInt(h.substr(0, 2), 16), g = parseInt(h.substr(2, 2), 16), b = parseInt(h.substr(4, 2), 16);
    return (0.299 * r + 0.587 * g + 0.114 * b) > 215;
  }

  // ---------- 1) Auswahlfelder ----------
  function apply(root) {
    var containers = root.querySelectorAll('.g-selector-container.g-selector-variants');
    Array.prototype.forEach.call(containers, function (c) {
      var label = c.querySelector('.g-selector-label');
      if (!label) return;

      var orig = label.getAttribute('data-nl-orig');
      if (!orig) {
        orig = label.textContent.trim();
        label.setAttribute('data-nl-orig', orig);
      }
      var display = LABELS[orig.toLowerCase()] || orig;

      var buttons = c.querySelectorAll('.g-selector-button');
      var active = c.querySelector('.g-selector-button-active');

      if (COLOR_LABEL.test(display) && buttons.length) {
        var allMapped = Array.prototype.every.call(buttons, function (b) { return !!colorFor(b.getAttribute('data-nl-name') || b.textContent); });
        if (allMapped) {
          Array.prototype.forEach.call(buttons, function (b) {
            if (b.classList.contains('nl-g-swatch')) return;
            var name = b.textContent.trim();
            var hex = colorFor(name);
            b.setAttribute('data-nl-name', name);
            b.setAttribute('title', name);
            b.setAttribute('aria-label', name);
            b.style.setProperty('--nl-swatch', hex);
            b.classList.add('nl-g-swatch');
            if (isLight(hex)) b.classList.add('nl-g-swatch--light');
          });
        }
      }

      var activeName = active ? (active.getAttribute('data-nl-name') || active.textContent.trim()) : '';
      var wantText = SHOW_VALUE.test(display) && activeName ? display + ': ' : display;
      var valEl = label.querySelector('.nl-g-value');
      var current = label.getAttribute('data-nl-text');
      if (current !== wantText || (SHOW_VALUE.test(display) && (!valEl || valEl.textContent !== activeName))) {
        label.setAttribute('data-nl-text', wantText);
        label.textContent = wantText;
        if (SHOW_VALUE.test(display) && activeName) {
          var v = document.createElement('span');
          v.className = 'nl-g-value';
          v.textContent = activeName;
          label.appendChild(v);
        }
      }
    });
  }

  // ---------- 2) Personalisierung sichtbar in den Warenkorb ----------
  // Liest alle Gelato-Textfelder aus: { "Geburtsjahr": "2002", ... }
  function personalizationValues() {
    var out = {};
    var fields = document.querySelectorAll('.gelato-customization-wrapper .g-selector-text');
    Array.prototype.forEach.call(fields, function (container) {
      var input = container.querySelector('input[type=text], textarea');
      if (!input) return;
      var value = (input.value || '').trim();
      if (!value) return;
      var label = container.querySelector('.g-selector-label');
      var name = label ? label.textContent.replace(/\*/g, '').trim() : '';
      out[name || 'Personalisierung'] = value;
    });
    return out;
  }

  function addToProps(props, values) {
    props = props || {};
    Object.keys(values).forEach(function (k) { props[k] = values[k]; });
    return props;
  }

  // ---------- 3) Nach dem Hinzufuegen: Seitenansicht oeffnen statt /cart ----------
  var SECTIONS = 'cart-drawer,cart-icon-bubble';

  function knopfZuruecksetzen() {
    Array.prototype.forEach.call(document.querySelectorAll('.product-form__submit'), function (b) {
      b.classList.remove('loading');
      b.removeAttribute('aria-disabled');
      var sp = b.querySelector('.loading__spinner');
      if (sp) sp.classList.add('hidden');
    });
  }

  function wagerlOeffnen(antwort) {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer || typeof drawer.renderContents !== 'function' || !antwort || !antwort.sections) return false;
    if (!antwort.id && antwort.items && antwort.items[0]) antwort.id = antwort.items[0].variant_id;
    drawer.classList.remove('is-empty');
    drawer.renderContents(antwort);
    knopfZuruecksetzen();
    return true;
  }

  // fetch('/cart/add.js') von Gelato abfangen
  if (window.fetch && !window.fetch.__nlPatched) {
    var origFetch = window.fetch;
    var patched = function (resource, init) {
      var gelatoAdd = false;
      try {
        var url = typeof resource === 'string' ? resource : (resource && resource.url) || '';
        if (/\/cart\/add(\.js)?(\?|$)/.test(url) && init && init.body) {
          var values = personalizationValues();
          var hasValues = Object.keys(values).length > 0;
          var isGelato = function (p) { return p && (p._customizationId || p._inPagePersonalization); };
          if (typeof init.body === 'string' && init.body.trim().charAt(0) === '{') {
            var data = JSON.parse(init.body);
            if (Array.isArray(data.items)) {
              data.items.forEach(function (it) {
                if (!isGelato(it.properties)) return;
                gelatoAdd = true;
                if (hasValues) it.properties = addToProps(it.properties, values);
              });
            } else if (isGelato(data.properties)) {
              gelatoAdd = true;
              if (hasValues) data.properties = addToProps(data.properties, values);
            }
            if (gelatoAdd && !data.sections) {
              data.sections = SECTIONS;
              data.sections_url = window.location.pathname;
            }
            init = Object.assign({}, init, { body: JSON.stringify(data) });
          } else if (init.body instanceof FormData && init.body.get('properties[_customizationId]')) {
            gelatoAdd = true;
            Object.keys(values).forEach(function (k) { init.body.set('properties[' + k + ']', values[k]); });
            if (!init.body.get('sections')) {
              init.body.set('sections', SECTIONS);
              init.body.set('sections_url', window.location.pathname);
            }
          }
        }
      } catch (err) { gelatoAdd = false; /* im Zweifel Original-Anfrage unveraendert senden */ }

      var antwort = origFetch.call(this, resource, init);
      if (!gelatoAdd) return antwort;

      return antwort.then(function (res) {
        if (!res.ok) return res; // Fehler (z. B. ausverkauft) zeigt Gelato selbst an
        return res.clone().json().then(function (json) {
          if (!wagerlOeffnen(json)) return res;
          // Gelato wuerde nach dieser Antwort auf /cart weiterleiten -> Antwort zurueckhalten,
          // der Artikel liegt bereits im Wagerl und die Seitenansicht ist offen.
          return new Promise(function () {});
        }).catch(function () { return res; });
      });
    };
    patched.__nlPatched = true;
    window.fetch = patched;
  }

  // ---------- Start ----------
  function init() {
    var wrap = document.getElementById('gelato-artwork-id') || document.querySelector('.gelato-customization-wrapper');
    var target = wrap || document.body;
    var scheduled = false;
    function run() { scheduled = false; apply(document); }
    run();
    var mo = new MutationObserver(function () {
      if (scheduled) return;
      scheduled = true;
      requestAnimationFrame(run);
    });
    mo.observe(target, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });
    if (!wrap) {
      var tries = 0;
      var t = setInterval(function () {
        tries++;
        var w = document.getElementById('gelato-artwork-id');
        if (w || tries > 40) { clearInterval(t); if (w) { mo.disconnect(); mo.observe(w, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] }); run(); } }
      }, 250);
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
